var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.2918 5.8335V13.3335C17.2918 14.2335 16.7752 15.0085 16.0252 15.3835C16.0335 15.2585 16.0418 15.1335 16.0418 15.0002V7.50016C16.0418 5.55016 14.4502 3.9585 12.5002 3.9585H5.52516C5.9085 3.21683 6.67516 2.7085 7.56683 2.7085H14.1668C15.8918 2.7085 17.2918 4.1085 17.2918 5.8335ZM12.5002 5.2085H5.00016C3.736 5.2085 2.7085 6.236 2.7085 7.50016V15.0002C2.7085 16.2643 3.736 17.2918 5.00016 17.2918H12.5002C13.7643 17.2918 14.7918 16.2643 14.7918 15.0002V7.50016C14.7918 6.236 13.7643 5.2085 12.5002 5.2085Z",
    fill: "#611BA5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.0038dd4a026477d5e8ab93f82c03e6aa.svg";
export { ForwardRef as ReactComponent };